import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="indice-formulario"
// El índice lateral del formulario de seguros (`opinables/seguros/_indice`): junto a cada sección,
// cuántos campos quedan sin dato, que son las filas que la ficha no pinta. Cuenta los sí/no en
// «Sin dato» y las cifras vacías de la sección, y lo recalcula con cada cambio.
//
// Cada sección empieza en el encabezado con su id y llega hasta el siguiente encabezado.
export default class extends Controller {
  static targets = ['pendientes']

  connect () {
    this.actualiza()
  }

  actualiza () {
    this.pendientesTargets.forEach(pendientes => {
      const sinDato = this.sinDatoEn(pendientes.dataset.seccion)

      pendientes.textContent = sinDato
      pendientes.hidden = sinDato === 0
      pendientes.title = `${sinDato} sin dato`
    })
  }

  sinDatoEn (id) {
    const encabezado = document.getElementById(id)
    let sinDato = 0

    const esSeccion = nodo => nodo && !nodo.matches('.rnk-FormsHeading')
    for (let nodo = encabezado?.nextElementSibling; esSeccion(nodo); nodo = nodo.nextElementSibling) {
      sinDato += nodo.querySelectorAll('.rnk-CampoSiNo_Radio[value=""]:checked').length
      sinDato += [...nodo.querySelectorAll('.rnk-CampoConUnidad input')].filter(input => !input.value.trim()).length
    }

    return sinDato
  }
}
